import React, { useState } from 'react';
import { styled } from '@this/constants/themes';
import type SegmentClass from '@this/src/domain/transit/segment';
import type { LegJson, LegSummaryJson } from '@this/src/domain/select_repository';

interface IndividualRouteModalProps {
  segment: SegmentClass;
  legSummary: LegSummaryJson;
}

const IndividualRouteModal: React.FC<IndividualRouteModalProps> = ({ segment, legSummary }) => {
  const [show, setShow] = useState(false);

  const renderTransportIcon = (leg: LegJson) => {
    if (leg.type === 'train' || leg.type === 'express' || leg.type === 'shin') {
      return <StyledImage src="/images/train.png" />;
    }
    if (leg.airline_name !== null) {
      return <StyledImage src="/images/plane.png" />;
    }
    if (leg.type === 'walk') {
      return <StyledImage src="/images/walk.png" />;
    }
    if (leg.type === 'bus') {
      return <StyledImage src="/images/bus.png" />;
    }
    return null;
  };

  return (
    <StyledModalWindow>
      <StyledButton onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
        詳細
      </StyledButton>
      {show && (
        <StyledContentWrapper>
          {segment.legs.map((le, q) => (
            <React.Fragment key={q}>
              {legSummary.indexes.includes(String(q + 1)) && (
                <StyledSummary>
                  <StyledArrowBox>{renderTransportIcon(le)}</StyledArrowBox>
                  <StyledSummaryDetail>
                    <StyledBoxContent>
                      <StyledLegTime>{le.from.time}</StyledLegTime>
                      <StyledSpaceStation>{le.from.name}</StyledSpaceStation>
                    </StyledBoxContent>
                    <StyledBoxContent>
                      <StyledLegTime />
                      <StyledSpace>{le.name}</StyledSpace>
                    </StyledBoxContent>
                    <StyledBoxContent>
                      <StyledLegTime>{le.to.time}</StyledLegTime>
                      <StyledSpaceStation>{le.to.name}</StyledSpaceStation>
                    </StyledBoxContent>
                  </StyledSummaryDetail>
                </StyledSummary>
              )}
            </React.Fragment>
          ))}
        </StyledContentWrapper>
      )}
    </StyledModalWindow>
  );
};

const StyledModalWindow = styled.div`
  position: relative;
  @media screen and (max-width: 767px) {
    position: static;
  }
`;

const StyledButton = styled.div`
  color: #999999;
  background: white;
  border: 1px solid #999999;
  border-radius: 3px;
  font-weight: bold;
  line-height: 15px;
  font-size: 10px;
  cursor: pointer;
  text-align: center;
  padding: 0 5px;
  white-space: nowrap;
`;

const StyledContentWrapper = styled.div`
  background-color: white;
  box-sizing: border-box;
  border: 1px solid #999999;
  color: #333;
  align-items: center;
  padding: 6px;
  justify-content: center;
  text-align: center;
  position: absolute;
  left: 0%;
  min-width: 300px;
  z-index: 1000;
  @media screen and (max-width: 767px) {
    right: 0;
    max-width: 90%;
    margin: 0 auto;
  }
`;

const StyledSummary = styled.div`
  padding: 5px;
  display: block;
  margin-bottom: 5px;
  clear: both;
`;

const StyledArrowBox = styled.div`
  background-image: url('/images/train-route-arrow.png');
  background-repeat: no-repeat;
  background-position: center center;
  color: white;
  width: 23px;
  height: 90px;
  text-align: center;
  vertical-align: middle;
  float: left;
  display: flex;
`;

const StyledImage = styled.img`
  height: 15px;
  margin: auto;
  background-color: #ffffff;
`;

const StyledSummaryDetail = styled.div`
  width: 250px;
  float: left;
`;

const StyledLegTime = styled.div`
  width: 40px;
  color: #1e90ff;
  font-size: 13px;
  font-weight: bold;
  height: 16px;
  vertical-align: middle;
  margin-right: 20px;
`;

const StyledSpace = styled.div`
  margin-right: 10px;
`;

const StyledSpaceStation = styled.div`
  margin-right: 10px;
  font-weight: bold;
`;

const StyledBoxContent = styled.div`
  display: flex;
  padding: 5px;
`;

export default IndividualRouteModal;
